// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton-skeleton___Kj-cU","background-shimmer":"Skeleton-background-shimmer___q+xzN"};